__webpack_require__.p = "/dm-poc/referrals-hub/";